/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Category_VideoInputs */

const en_category_video = /** @type {(inputs: Category_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

const zh_hans1_category_video = /** @type {(inputs: Category_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频`)
};

const pt_br2_category_video = /** @type {(inputs: Category_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vídeo`)
};

const es_category_video = /** @type {(inputs: Category_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

const fr_category_video = /** @type {(inputs: Category_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vidéo`)
};

const de_category_video = /** @type {(inputs: Category_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

const ru_category_video = /** @type {(inputs: Category_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видео`)
};

const it_category_video = /** @type {(inputs: Category_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

/**
* | output |
* | --- |
* | "Video" |
*
* @param {Category_VideoInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const category_video = /** @type {((inputs?: Category_VideoInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Category_VideoInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_category_video(inputs)
	if (locale === "pt-BR") return pt_br2_category_video(inputs)
	if (locale === "es") return es_category_video(inputs)
	if (locale === "fr") return fr_category_video(inputs)
	if (locale === "de") return de_category_video(inputs)
	if (locale === "ru") return ru_category_video(inputs)
	if (locale === "it") return it_category_video(inputs)
	return en_category_video(inputs)
});